var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "3c6342eeaa295c8c7a86d2e5ae8a112613e56c43"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["nft-gallery@kodadot"] = {
  id: "3c6342eeaa295c8c7a86d2e5ae8a112613e56c43"
};